'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { logEvent } from 'firebase/analytics'
import { analytics } from '@/helpers/firebase/firebase'

export function NavigationEvents() {
    const pathname = usePathname()
    const searchParams = useSearchParams()

    useEffect(() => {
        if (!analytics) return;
        const url = pathname.replace('/', '');
        logEvent(analytics, 'screen_view', {
            firebase_screen: url,
            firebase_screen_class: 'App',
        })
    }, [pathname, searchParams])

    return null
}
